
import SectionForm from 'containers/Forms/SectionForm';
import SectionProgress from 'containers/Progress/Section';
import TeacherSectionProgress from 'containers/Progress/TeacherSection';
import { isUserTeacher } from 'helpers/user';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Spinner } from 'UI';
import { setPageTitle, setPageActions } from 'actions/header';
import Modal from 'containers/Modals/Modal';
import * as microsoftTeams from "@microsoft/teams-js";

import { getGroupByGraphId, clearGroupByGraphId } from "actions/groups";

class MyAssessments extends Component {
	constructor(props) {
		super(props);

		this.state = {
			sectionId: null,
			noSectionFound: false,
			teamsContext: null,
			isLoading: false,
			myGroups: [],
			group: null,
		};
	}

	UNSAFE_componentWillMount = () => {
		this.props.setPageActions([{
			type: 'icon',
			onClick: this.toggleGroupSettings,
			icon: 'cog_bw',
		}]);

		this.props.setPageTitle(this.props.translate('assessments-header-overview'));
	}

	componentDidMount = () => {
		this.initComponent();
	}

	toggleGroupSettings = (shouldReload) => {
		this.setState({ groupForm: !this.state.groupForm });

		if (shouldReload == true) {
			microsoftTeams.app.getContext().then((context) => {

				this.props.clearGroupByGraphId(context.team.groupId);
				this.props.getGroupByGraphId(context.team.groupId).then((group) => {
					this.setState({ group: group });
				});
			});
		}
	}

	initComponent = () => {
		this.setState({ isLoading: true });
		this.loadContext();
	}

	loadContext() {
		microsoftTeams.app.getContext().then((context) => {
			this.props.getGroupByGraphId(context.team.groupId).then((group) => {
				if (group != null) {
					this.setState({ isLoading: false, group: group, sectionId: group.id, noSectionFound: false, teamsContext: context });
				} else {
					this.setState({ noSectionFound: true, teamsContext: context, isLoading: false });
				}
			});
		});
	}

	renderStudentView() {
		return (
			<div id="section-assessment" className="single-section form">
				<SectionProgress
					groupId={this.state.group.id}
					userId={this.props.currentUser.id}
				/>
			</div>
		);
	}

	teamsTabCloseForm = () => {
		this.setState({ noSectionFound: false }, () => {
			window.location = window.location.href;
		})
	}

	renderContent = () => {
		const isTeacher = isUserTeacher(this.props.currentUser);

		return (
			<div>
				{this.state.group != null ?
					<Modal isOpen={this.state.groupForm} onClose={this.toggleGroupSettings} title={this.state.group.title}>
						<SectionForm
							onAbort={this.toggleGroupSettings}
							editView
							section={this.state.group}
						/>
					</Modal>
					: null}

				{isTeacher ?
					<div id="section-pupils" className="single-section form">
						<TeacherSectionProgress
							groupId={this.state.group.id}
						/>
					</div>
					: null}

				{this.state.isLoading == false && isTeacher == false && this.state.noSectionFound == false ?
					this.renderStudentView()
					: null}
			</div>
		)
	}

	render() {
		if (this.state.isLoading) {
			return <Spinner center />
		}

		const isTeacher = isUserTeacher(this.props.currentUser);

		return (
			<div className="container my_assessments">
				{this.state.group != null ? this.renderContent() : null}

				{this.state.noSectionFound == true && isTeacher ?
					<SectionForm
						editView={false}
						teamsContext={this.state.teamsContext}
						teamsTabCloseForm={this.teamsTabCloseForm}
						tab="assessments"
						onboarding={true}
					/>
					: null}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		translate: translate(state.Languages.translations),
		currentUser: state.user.currentUser,
	};
}

export default connect(mapStateToProps, {
	setPageTitle,
	setPageActions,
	getGroupByGraphId,
	clearGroupByGraphId
})(MyAssessments);
